// English rendering of system-generated (Arabic-stored) notification titles.
const EXACT = {
  "إعلان جديد بانتظار المراجعة": "New ad awaiting review",
  "⏰ عميل بانتظار الرد": "⏰ Customer awaiting reply",
  "تم نشر إعلانك": "Your ad is published",
  "تم نشر إعلانك 🎉": "Your ad is published 🎉",
  "إعلان معدّل بانتظار المراجعة": "Edited ad awaiting review",
  "طلب ترقية إعلان جديد": "New ad promotion request",
  "إعلان جديد منشور": "New ad published",
  "طلب اعتماد جهة جديد": "New business approval request",
  "طلب اعتماد شركة جديد": "New company approval request",
  "📋 ملخص نشاط اليوم": "📋 Today's activity summary",
  "تم الدفع ونشر إعلانك ✅": "Payment received — your ad is published ✅",
  "تمت الموافقة على إعلانك ✅ — ادفع رسوم النشر ليُنشر فوراً": "Your ad was approved ✅ — pay the posting fee to publish it now",
  "تمت الموافقة على إعلانك ✅": "Your ad was approved ✅",
  "إشعار حوالة بنكية جديد": "New bank transfer notice",
  "بلاغ جديد عن إعلان": "New ad report",
  "بلاغ جديد عن مستخدم": "New user report",
  "تم اعتماد حساب شركتك": "Your company account is approved",
  "تم اعتماد شركتك ✅": "Your company is approved ✅",
  "إعلانك ينتهي قريباً ⏳": "Your ad expires soon ⏳",
  "انتهت مدة إعلانك": "Your ad has expired",
  "خدمة عملاء بازارو": "Bazaroo Customer Service",
  "تم إسناد محادثة إليك": "A conversation was assigned to you",
  "تم تمييز إعلانك ⭐": "Your ad is now featured ⭐",
  "تم رفض طلب شركتك": "Your company request was rejected",
  "تم رفض طلب اعتماد الشركة": "Company approval request rejected",
  "انتهت رخصة شركة معتمدة — تم إيقاف إعلاناتها": "An approved company's licence expired — its ads were paused",
  "رخصة شركة معتمدة تنتهي خلال 7 أيام — لم تُجدَّد": "An approved company's licence expires in 7 days — not renewed",
  "مستخدم جديد بانتظار الموافقة": "New user awaiting approval",
  "طلب سحب رصيد جديد": "New withdrawal request",
  "خصم إعلانك ينتهي غداً 🏷️": "Your ad discount ends tomorrow 🏷️",
  "طلب دعم محوّل من المساعد الذكي": "Support request forwarded by the AI assistant",
  "طلب تجديد رخصة": "Licence renewal request",
  "طلب حجز موعد جديد 📅": "New booking request 📅",
  "تم إنهاء محادثة خدمة العملاء": "Customer service chat closed",
  "تم تفعيل حسابك": "Your account is activated",
  "تمت إضافة رصيد إلى محفظتك": "Balance added to your wallet",
  "محادثة خدمة عملاء جديدة (بانتظار موظف)": "New customer service chat (waiting for an agent)",
  "⚠️ تذكير أخير: رخصة المركز تنتهي خلال 7 أيام": "⚠️ Final reminder: the centre's licence expires in 7 days",
  "تم منحك صلاحية مدير في بازارو": "You were granted admin access on Bazaroo",
  "صلاحية جديدة": "New permission",
  "تم قبول حجزك ✅": "Your booking was accepted ✅",
  "تم رفض إعلانك": "Your ad was rejected",
  "تم رفض حجزك": "Your booking was declined",
  "تم رفض الحجز": "Your booking was declined",
  "تم إلغاء الحجز": "Booking cancelled",
  "ألغى مقدّم الخدمة حجزك": "The provider cancelled your booking",
  "تم إلغاء حجزك تلقائياً": "Your booking was cancelled automatically",
  "تذكير: موعدك بعد ساعتين ⏰": "Reminder: your appointment is in 2 hours ⏰",
  "رسالة جديدة": "New message",
};
const PATTERNS = [
  [/^دفعة جديدة (.+)$/, "New payment $1"],
  [/^بلاغ جديد عن إعلان (.+)$/, "New ad report $1"],
  [/^خدمة العملاء — (.+)$/, "Customer service — $1"],
  [/^رخصة شركة معتمدة تنتهي خلال (\d+) (يوماً|أيام|يوم)$/, "An approved company's licence expires in $1 days"],
  [/^الملخص اليومي لنشاط المشرفين — (.+)$/, "Daily moderators activity summary — $1"],
];

export const notifTitle = (t, lang) => {
  if (lang !== "en" || !t) return t;
  if (EXACT[t]) return EXACT[t];
  for (const [re, en] of PATTERNS) if (re.test(t)) return t.replace(re, en);
  return t;
};
